// extracted by mini-css-extract-plugin
export default {"list":"hA3c9OWsGVCXyIcFKqUs","loadMore":"GNcenLPsvGUuruMu8SKE","listItem":"EDmwpOtnSJNV4A073oJQ","groupTitle":"bTpiWX2XXPY7Xwf2ScWQ","avatar":"bg1s0IhnHr3IUQkMlWHC"};